import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.html',
  styleUrl: './auth-callback.css',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private readonly msalService: MsalService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.msalService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result?.account) {
          this.msalService.instance.setActiveAccount(result.account);
        }
        void this.router.navigateByUrl('/');
      },
      error: () => {
        void this.router.navigate(['/unauthorized']);
      },
    });
  }
}
